import { render, staticRenderFns } from "./WmsGroupDialog.vue?vue&type=template&id=87de0762"
import script from "./WmsGroupDialog.vue?vue&type=script&lang=js"
export * from "./WmsGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports